<template>
  <div class="container">
    <section>
      <h1>{{ $t('errorPages:error500.headline') }}</h1>
      <p>{{ $t('errorPages:error500.firstParagraph') }}</p>
      <p v-dompurify-html="$t('errorPages:error500.secondParagraph')" />
      <p>
        {{ $t('errorPages:cta.furtherQuestions') }}
        <!-- eslint-disable-next-line vue/singleline-html-element-content-newline -->
        <router-link-simple :to="{ name: 'ContactGuest' }">
          {{ $t('errorPages:cta.routerLink') }}
        </router-link-simple>
      </p>
    </section>

    <section>
      <p class="small">
        <strong>{{ $t('errorPages:errormessageTitle') }}</strong><br>
        {{ $t('errorPages:error500.errormessageInformation') }} {{ $route.path }}
      </p>
    </section>

    <section>
      <button
        class="btn btn-primary"
        type="button"
        @click="$router.go(-1)"
      >
        {{ $t('errorPages:backButton') }}
      </button>
    </section>
  </div>
</template>

<script>
import RouterLinkSimple from 'components/RouterLinkSimple.vue';

export default {
  name: 'Error500Content',
  components: {
    RouterLinkSimple,
  },
  i18nOptions: { namespaces: 'errorPages' },
};
</script>
